/**
 * @generated SignedSource<<61fd77f67704446d39e14cfca3f5fc87>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RepeatTypeEnum = "daily" | "monthly" | "weekly" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PromotionRepeatText_promotion$data = {
  readonly isRepeat: boolean;
  readonly repeatType: RepeatTypeEnum | null;
  readonly repeatValue: string | null;
  readonly " $fragmentType": "PromotionRepeatText_promotion";
};
export type PromotionRepeatText_promotion$key = {
  readonly " $data"?: PromotionRepeatText_promotion$data;
  readonly " $fragmentSpreads": FragmentRefs<"PromotionRepeatText_promotion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PromotionRepeatText_promotion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isRepeat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repeatType",
      "storageKey": null
    }
  ],
  "type": "Promotion",
  "abstractKey": null
};

(node as any).hash = "038e256528e395a1ac7cc789485f20b2";

export default node;
